import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";
import { Alert } from "@mapmycustomers/ui";

import ButtonLink from "@app/component/ButtonLink";
import { getLeadGenPlan, isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";
import showLeadFinderUpsell from "@app/util/leadFinder/showLeadFinderUpsell";

import styles from "./BasicPlanBanner.module.scss";

interface Props {
  isOwner: boolean;
  leadGenPlan?: LeadFinderSubscriptionPlan;
}

const BasicPlanBanner: React.FC<Props> = ({ isOwner, leadGenPlan }) => {
  const analytics = useAnalytics();
  const intl = useIntl();

  const handleClick = useCallback(() => {
    showLeadFinderUpsell(leadGenPlan, intl, isOwner);
    analytics.clicked(["Get 3x the results by upgrading"]);
  }, [analytics, intl, isOwner, leadGenPlan]);

  return (
    <Alert
      className={styles.container}
      closable
      message={intl.formatMessage(
        {
          id: "map.tool.leadFinder.basic.banner",
          defaultMessage: "Get 3x the results per search by <a>upgrading Lead Finder</a>",
          description: "Lead Finder basic plan banner",
        },
        {
          a: (text) => <ButtonLink onClick={handleClick}>{text}</ButtonLink>,
        }
      )}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isOwner: isCurrentUserOwner(state),
  leadGenPlan: getLeadGenPlan(state),
});

export default connect(mapStateToProps)(BasicPlanBanner);
